import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { AuthProvider } from './context/AuthContext';
import { EnvironmentProvider } from './context/EnvironmentContext';
import { router } from './router';
import { queryClient } from './lib/query-client';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <EnvironmentProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </EnvironmentProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
